import React from "react";
import { useDisplayOptionContext } from "@/hooks/useDisplayOptionContext";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { useGetFacilitiesV2Query } from "@/features/api/apiSlice";
import { Skeleton } from "../ui/skeleton";

export const NoUnitsAvailable = () => {
    const options = useDisplayOptionContext();

    const { data, error, isLoading } = useGetFacilitiesV2Query({
        ids: options.facilityIds[0],
    });

    return (
        <Card className="units-unavailable-card">
            <CardHeader>
                <CardTitle>
                    <h2>
                        We're sorry, there are no units available at this time
                    </h2>
                </CardTitle>
            </CardHeader>
            <CardContent>
                {error ? (
                    "Oh no, there was an error! {error.status}"
                ) : isLoading ? (
                    <Skeleton className="tw:w-[200px] tw:h-[20px] tw:rounded-full" />
                ) : data ? (
                    <p>
                        For more information on unit availability, please call{" "}
                        <a href={`tel:${data.data[0].phone}`}>{data.data[0].phone}</a>
                    </p>
                ) : null}
            </CardContent>
        </Card>
    );
};
